import { rowStartNumTemplateImg3, rowStartNumTemplateImg6 } from '@/constants/excel';
import * as ExcelJS from 'exceljs';

export const calculateWorksheetPages = (
  worksheet: ExcelJS.Worksheet,
  imgCountTemplate = 3,
): number => {
  const usedRange = worksheet.dimensions;
  if (!usedRange) return 1;

  // Count non-empty rows more accurately
  let actualRowCount = 0;
  for (let row = usedRange.top; row <= usedRange.bottom; row++) {
    const rowData = worksheet.getRow(row);
    let hasContent = false;

    rowData.eachCell((cell) => {
      if (
        cell.value !== null &&
        cell.value !== undefined &&
        cell.value !== ''
      ) {
        hasContent = true;
      }
    });

    if (hasContent) {
      actualRowCount++;
    }
  }

  // Page configuration constants
  const PAGE_CONFIG = {
    REPORT_PAGE: {
      'Ⅳ. 성능점검표': 5,
      'Ⅳ. 결과보고서': 3,
    },
    DEFAULT_TEMPLATE3_PAGE: Object.fromEntries(
      Object.entries(rowStartNumTemplateImg3).map(([key, value]) => [
        key,
        value.pageBreakArr?.length  ? value.pageBreakArr?.length + 1 : 0,
      ])
    ),
    DEFAULT_TEMPLATE6_PAGE: Object.fromEntries(
      Object.entries(rowStartNumTemplateImg6).map(([key, value]) => [
        key,
        value.pageBreakArr?.length  ? value.pageBreakArr?.length + 1 : 0,
      ])
    ),
  } as const;

  const DEFAULT_ROWS_PER_PAGE = 25;

  // Helper function to find page count by pattern matching
  const findPageByPattern = (pageConfig: Record<string, number>, worksheetName: string): number | undefined => {
    return Object.entries(pageConfig).find(([pattern]) => 
      worksheetName.includes(pattern)
    )?.[1];
  };

  // Get template-specific page configuration
  const templatePageConfig = imgCountTemplate === 6 
    ? PAGE_CONFIG.DEFAULT_TEMPLATE6_PAGE 
    : PAGE_CONFIG.DEFAULT_TEMPLATE3_PAGE;
  
  // Calculate number of pages with fallback chain
  const numberOfPage = 
    findPageByPattern(PAGE_CONFIG.REPORT_PAGE, worksheet.name) ??
    findPageByPattern(templatePageConfig, worksheet.name) ??
    Math.ceil(actualRowCount / DEFAULT_ROWS_PER_PAGE);

  const factor = Math.max(1, Math.floor((usedRange.right + 11) / 12));

  const estimatedPages = Math.max(1, Math.ceil(numberOfPage * factor));

  return estimatedPages;
};
